import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enCL from './translations/en/en-CL.json';
import esCL from './translations/es/es-CL.json';
import enMX from './translations/en/en-MX.json';
import esMX from './translations/es/es-MX.json';
// import enPE from './translations/en/en-PE.json';
// import esPE from './translations/es/es-PE.json';
// import enPEMS from './translations/en/en-PEMS.json';
// import esPEMS from './translations/es/es-PEMS.json';
import enUS from './translations/en/en-US.json';
import esUS from './translations/es/es-US.json';

const resources = {
	'en-CL': enCL,
	'es-CL': esCL,
	'en-MX': enMX,
	'es-MX': esMX,
	'es-CO': esMX,
	'en-CO': enMX,
	// 'en-PE': enPE,
	// 'es-PE': esPE,
	// 'es-PEMS': esPEMS,
	// 'en-PEMS': enPEMS,
	'en-US': enUS,
	'es-US': esUS
};

i18n.use(initReactI18next).init({
	resources,
	lng: 'es-CL',
	keySeparator: false,
	// debug: true,
	interpolation: {
		escapeValue: false
	}
});

export default i18n;
